import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, UserService} from "../services";
import {Subject} from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardService} from "../services/card.service";
import {Card} from "../models/card";
import {MatDialog} from "@angular/material/dialog";
import {MinusServiceDialogComponent} from "./dialog/minusServiceDialog.component";
import {FormGroup} from "@angular/forms";
import {DeleteCardDialogComponent} from "../card/dialog/deleteCardDialog.component";
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import {ChangeNumberDialogComponent} from "../card/dialog/changeNumberDialog.component";
import {AddVoucherDialogComponent} from "../card/dialog/addVoucherDialog.component";
import {CardVoucher} from "../models/cardVoucher";
import {SuspendCardVoucherDialogComponent} from "../card/dialog/suspendCardVoucherDialog.component";
import {
    UnsuspendCardDialogComponent
} from "../card/dialog/unsuspendCardDialog.component";
import {TakeCardDialogComponent} from "./dialog/takeCardDialog.component";
import {VirtualReceiptService} from "../pos/service/virtualReceipt.servicee";
import {VirtualReceipt} from "../pos/model/virtualReceipt";
import {OpenBillDialogComponent} from "./dialog/openBillExists.component";
import {
    MarkAsReturnedDialogComponent,
} from "../card/dialog/markAsReturnedDialog.component";

@Component({
    templateUrl: './customerCards.component.html',
    styleUrls: ['./customerCards.component.scss']
})
export class CustomerCardsComponent implements OnDestroy, OnInit {
    id: string;
    user: User;
    cards: Card[];
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    dialogRef: any;
    exitDialogRef: any;
    deleteDialogRef: any;
    changeNumberDialogRef: any;
    addVoucherDialogRef: any;
    suspendVoucherDialogRef: any;
    unsuspendCardDialogRef: any;
    virtualReceipt: VirtualReceipt|null;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private cardService: CardService,
        private virtualReceiptService: VirtualReceiptService,
        public _matDialog: MatDialog,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];

        this.virtualReceiptService.getByCustomer(this.id).subscribe((res: VirtualReceipt) => {
            this.virtualReceipt = res;
            this.dialogRef = this._matDialog.open(OpenBillDialogComponent, {
                panelClass: 'open-bill-exists-dialog',
                data      : {
                    action : 'show',
                    locale: this.locale,
                    virtualReceipt: this.virtualReceipt
                },
                width: '850px',
            });
        }, error => {
            this.virtualReceipt = null;
        });

        this.cardService.findCustomerCards(this.id)
            .pipe(first())
            .subscribe((customerCards: Card[]) => {
                this.cards = customerCards;
            });

        this.user = this.route.snapshot.data.userData;
        this.componentTitleService.addPart(this.user.firstName + ' ' + this.user.lastName);
        this.componentTitleService.addPart('Cards');
    }

    ngOnDestroy(): void {

    }

    acceptEntrance(card: Card): void {
        this.cardService.acceptEntrance(card.cardNumber, card.uuid).pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Accepted successfully', {keepAfterRouteChange: true});
                    card.entranceAccepted = true;
                },
                error => {
                    this.alertService.error(error);
                });
    }

    acceptExit(card: Card): void {
        if (!this.virtualReceipt) {
            this.cardService.acceptExit(card.cardNumber, card.uuid).pipe(first())
                .subscribe(
                    data => {
                        this.alertService.success('Accepted successfully', {keepAfterRouteChange: true});
                        card.exitAccepted = true;

                        if (card.credits === 0) {
                            this.exitDialogRef = this._matDialog.open(TakeCardDialogComponent, {
                                panelClass: 'take-card-dialog',
                                data: {
                                    action: 'show',
                                    locale: this.locale,
                                    card: card
                                },
                                width: '700px',
                            });

                            this.exitDialogRef.disableClose = true;
                            this.exitDialogRef.backdropClick().subscribe(_ => {

                            });
                        }
                    },
                    error => {
                        this.alertService.error(error);
                    });
        } else {
            this.dialogRef = this._matDialog.open(OpenBillDialogComponent, {
                panelClass: 'open-bill-exists-dialog',
                data      : {
                    action : 'show',
                    locale: this.locale,
                    virtualReceipt: this.virtualReceipt
                },
                width: '850px',
            });

            this.dialogRef.afterClosed()
                .subscribe((response: FormGroup) => {
                    if (!response) {
                        return;
                    }

                    this.cardService.acceptExit(card.cardNumber, card.uuid).pipe(first())
                        .subscribe(
                            data => {
                                this.alertService.success('Accepted successfully', {keepAfterRouteChange: true});
                                card.exitAccepted = true;

                                if (card.credits === 0) {
                                    this.exitDialogRef = this._matDialog.open(TakeCardDialogComponent, {
                                        panelClass: 'take-card-dialog',
                                        data: {
                                            action: 'show',
                                            locale: this.locale,
                                            card: card
                                        },
                                        width: '700px',
                                    });

                                    this.exitDialogRef.disableClose = true;
                                    this.exitDialogRef.backdropClick().subscribe(_ => {

                                    });
                                }
                            },
                            error => {
                                this.alertService.error(error);
                            });

                }, (err) => {
                    console.log(err);
                });
        }
    }

    openMinusServiceDialog(card: Card): void {
        this.dialogRef = this._matDialog.open(MinusServiceDialogComponent, {
            panelClass: 'minus-service-form-dialog',
            data      : {
                action : 'show',
                locale: this.locale,
                card: card
            },
            width: '700px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                let data = response.getRawValue();

                this.cardService.minusItem(card.uuid, card.cardNumber, data.service.id)
                    .pipe(first())
                    .subscribe(
                        response => {
                            this.cardService.findCustomerCards(this.id)
                                .pipe(first())
                                .subscribe((customerCards: Card[]) => {
                                    this.cards = customerCards;
                                });
                        },
                        error => {
                            console.log(error);
                        }
                    )

            }, (err) => {
                console.log(err);
            });
    }

    showConfirmCardDeleteDialog(card: Card): void {
        this.deleteDialogRef = this._matDialog.open(DeleteCardDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                card: card,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.cardService.delete(card.uuid).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    markCardAsReturnedDialog(card: Card): void {
        this.deleteDialogRef = this._matDialog.open(MarkAsReturnedDialogComponent, {
            panelClass: 'mark-as-returned-dialog',
            data      : {
                action : 'show',
                card: card,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.cardService.markAsReturned(card.uuid).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showChangeCardNumberDialog(card: Card): void {
        this.changeNumberDialogRef = this._matDialog.open(ChangeNumberDialogComponent, {
            panelClass: 'change-number-form-dialog',
            data      : {
                action : 'change-number',
                card: card,
            },
            width: '350px',
        });

        this.changeNumberDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.cardService.changeNumber(card.uuid, response.getRawValue().number).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.changeNumberDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showAddVoucherDialog(card: Card, firstTimeVoucher: boolean): void {
        this.addVoucherDialogRef = this._matDialog.open(AddVoucherDialogComponent, {
            panelClass: 'add-voucher-dialog',
            data      : {
                action : 'add-voucher',
                card: card,
                firstTimeVoucher: firstTimeVoucher
            },
            width: '850px',
        });

        this.addVoucherDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                var formData = response.getRawValue();

                this.cardService.addVoucher(card.cardNumber, formData.voucher.id, formData.quantity, formData.expirationDate).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.addVoucherDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showSuspendVoucherDialog(card: Card, voucher: CardVoucher): void {
        this.suspendVoucherDialogRef = this._matDialog.open(SuspendCardVoucherDialogComponent, {
            panelClass: 'suspend-card-voucher-dialog',
            data      : {
                action : 'suspend-voucher',
                card: card,
                voucher: voucher
            },
            width: '650px',
        });

        this.suspendVoucherDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                var formData = response.getRawValue();

                this.cardService.suspendCardVoucher(card.uuid, card.cardNumber, voucher.uuid, formData.days).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    }, error => {
                        this.alertService.error("Unable to suspend selected voucher.");
                    });

                this.suspendVoucherDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showUnsuspendCardDialog(card: Card): void {
        this.unsuspendCardDialogRef = this._matDialog.open(UnsuspendCardDialogComponent, {
            panelClass: 'unsuspend-card-dialog',
            data      : {
                action : 'unsuspend-card',
                card: card,
            },
            width: '650px',
        });

        this.unsuspendCardDialogRef.afterClosed()
            .subscribe((response: string) => {
                if (!response) {
                    return;
                }

                this.cardService.unsuspendCard(card.uuid, card.cardNumber).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    }, error => {
                        this.alertService.error("Unable to unsuspend card.");
                    });

                this.unsuspendCardDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    getPdf(user: User, card: Card): void {
        PdfMakeWrapper.setFonts(pdfFonts);

        const url = 'https://bodyspace.pl/';
        const pdf = new PdfMakeWrapper();

        // pdf.add({text: user.firstName + ' ' + user.lastName, alignment: 'left'});
        // pdf.add({text: 'Card number: ' + card.cardNumber, alignment: 'left'});

        pdf.add({columns: [
                {
                    width: '80%',
                    text: user.firstName + ' ' + user.lastName +
                        '\n' +
                        user.phone +
                        '\n' +
                        user.email +
                        '\n' +
                        'Card number: ' + card.cardNumber
                },
                {
                    width: 'auto',
                    qr: card.cardNumber,
                    alignment: 'right'
                }
            ],
            columnGap: 10
        });

        // pdf.add({ qr: card.cardNumber , alignment: 'right'});
        pdf.footer({text: url, margins: [0, 0, 0, 0]});

        pdf.create().download();
    }
}
